import axios from 'axios';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import DogWithBoll from '../Assets/Images/dogwithball.gif';
import Video from '../components/Video/Video';
import { useLocation } from 'react-router-dom';

const VideoHome = () => {
  const [paginate, setPaginate] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false); // Separate state for pagination loading
  const [rounds, setRounds] = useState([]);
  const [noData, setNoData] = useState(false);
  const [oxygenVideos, setOxygenVideos] = useState([]);
  const [paidLoveReact, setPaidLoveReact] = useState([]);
  const [matchedVideoLoaded, setMatchedVideoLoaded] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const scrollPositionRef = useRef(0);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const file = searchParams.get('file') || searchParams.get('video');

  const handleBeforeLoad = useCallback(() => {
    scrollPositionRef.current = window.scrollY;
  }, []);

  const handleAfterLoad = useCallback(() => {
    setTimeout(() => {
      window.scrollTo(0, scrollPositionRef.current);
    }, 0);
  }, []);

  const getCurrentUser = useCallback(() => {
    if (localStorage.getItem("auth_token")) {
      axios
        .get('api/user_info')
        .then((res) => {
          if (res.data.status === 200) {
            setCurrentUser(res.data.users);
          }
        })
        .catch((error) => {
          console.error("Error fetching current user:", error);
          setCurrentUser(null);
        })
        .finally(() => {
          setLoadingUser(false);
        });
    } else {
      setLoadingUser(false);
    }
  }, []);

  const getVideoFeed = useCallback((pageNum) => {
    if (totalPage !== 0 && pageNum > totalPage) return;

    // handleBeforeLoad();
    setLoadingMore(true);

    axios.get(`api/user/audition/videofeed/videos?page=${pageNum}`).then((res) => {
      setLoadingMore(false);
      if (res.data.status === 200) {
        setRounds((prevRounds) => [...prevRounds, ...res.data.totalVideos]);
        setTotalPage(res.data.lastPage);
        setPaginate(pageNum + 1);
        setLoading(false); // Set loading to false after first page loads
        if (pageNum >= res.data.lastPage) {
          setNoData(true);
        }

        // handleAfterLoad();
      }
    }).catch((error) => {
      console.error("Error fetching videos:", error);
      setLoadingMore(false);
      setLoading(false); // Set loading to false even on error
    });
  }, [totalPage]);

  const loadVideos = useCallback(() => {
    setMatchedVideoLoaded(false);
    if (file) {
      axios.get(`api/user/audition/videofeed/video?file=${file}`)
        .then((res) => {
          if (res.data.status === 200 && res.data.video[0]) {
            setRounds([res.data.video[0]]);
            setPaginate(2);
            setMatchedVideoLoaded(true);
            setLoading(false);
            getVideoFeed(2); // Load page 2 after setting matched video
          } else {
            setRounds([]);
            setMatchedVideoLoaded(true);
            getVideoFeed(1); // Load page 1 if no matched video
          }
        }).catch((error) => {
          console.error("Error fetching matched video:", error);
          setMatchedVideoLoaded(true);
          getVideoFeed(1);
        });
    } else {
      setMatchedVideoLoaded(true);
      getVideoFeed(1); // Load first page
    }
  }, [file, getVideoFeed]);

  const getLoveReact = () => {
    axios.get('api/user/audition/videofeed/country/loveReact').then((res) => {
      if (res.data.status === 200) {
        setPaidLoveReact(res.data.loveReact);
      }
    }).catch((error) => {
      console.error("Error fetching love react:", error);
    });
  };

  const FeedRefresh = () => {
    setRounds([]);
    setPaginate(1);
    setNoData(false);
    setLoading(true);
  };

  useEffect(() => {
    getCurrentUser();
    getLoveReact();
  }, []);

  useEffect(() => {
    loadVideos();
  }, [file]);

  return (
    <>
      <InfiniteScroll
        dataLength={rounds.length}
        next={() => getVideoFeed(paginate)}
        hasMore={!noData}
        loader={
          !noData ? (
            <div className="text-center mt-4">
              <i className="fas fa-spinner fa-pulse text-warning"></i>&nbsp;
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img src={DogWithBoll} style={{ height: 250, width: 500 }} alt="DogWithBoll" />
              <h4 className="text-center text-warning">No video found!</h4>
            </div>
          )
        }
        refreshFunction={FeedRefresh}
        pullDownToRefresh
        pullDownToRefreshThreshold={50}
        endMessage={
          <p style={{ textAlign: 'center' }}>
            <b>You have seen it all</b>
          </p>
        }
      >
        <Video
          style={{ minHeight: '30vh' }}
          paidLoveReact={paidLoveReact}
          rounds={rounds}
          loading={loading}
          loadingMore={loadingMore}
          currentUser={currentUser}
        />
      </InfiniteScroll>
    </>
  );
};

export default VideoHome;